var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.111,
    height: 14,
    viewBox: "0 0 3.111 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f6f6f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.556,16.889a1.556,1.556,0,1,0,1.556,1.556A1.556,1.556,0,0,0,21.556,16.889Zm0-5.444A1.556,1.556,0,1,0,23.111,13,1.556,1.556,0,0,0,21.556,11.444Zm0-5.444a1.556,1.556,0,1,0,1.556,1.556A1.556,1.556,0,0,0,21.556,6Z",
    transform: "translate(-20 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotMenu);
export default __webpack_public_path__ + "static/media/dot_menu.5d52488f712d27e86ec4729b0c320361.svg";
export { ForwardRef as ReactComponent };